

























































































































































































import { Prop, Component, Vue } from "vue-property-decorator";
import InvoiceHeader from "../components/InvoiceHeader.vue";
import VToolbar from "../../common/components/VToolbar.vue";
import InvoiceItem from "../components/InvoiceItem.vue";
import Invoice from "../../../usecases/accounting/invoice";
import InvoiceService from "../../../usecases/accounting/invoice-service";
import MoveEvent from "../presenters/move-event";
import InvoiceItemModel from "@/usecases/accounting/invoice-item";
import { client } from "../../../api/request";
import InvoiceApi from "@/api/accounting/invoice-api";
import InvoiceStatus from "@/usecases/accounting/invoice-status";
import InvoiceStatusTranslater from "@/usecases/accounting/invoice-status-translater";
import BankAccountApi from "@/api/accounting/bank-account-api";
import BankAccount from "../../../entities/bank-account";
import BankAccountOption from "../presenters/bank-account-option";
import VInputWithDropdown from "../../../common/ui/components/VInputWithDropdown.vue";
import BillingRuleApi from "../../../accounting/api/billing-rule-api";
import UnitApi from "@/accounting/api/unit-api";
import UnitOption from "../presenters/unit-option";
import SelectOption from "../../../common/ui/presenters/select-option";
import PrintApi from "../../../api/accounting/print-api";
import TextTemplateModal from "@/views/TextTemplateModal.vue";
import LoadingButton from "@/components/LoadingButton.vue";

const printApi = new PrintApi(client);
const billingRuleApi = new BillingRuleApi(client);
const bankAccountApi = new BankAccountApi(client);
const invoiceApi = new InvoiceApi(client);
const unitApi = new UnitApi(client);
const service = new InvoiceService(invoiceApi, billingRuleApi);

@Component({
  components: {
    TextTemplateModal,
    VInputWithDropdown,
    VToolbar,
    InvoiceHeader,
    InvoiceItem,
    LoadingButton
  }
})
export default class EditInvoicePage extends Vue {
  @Prop({ required: true }) id!: string;

  textTemplateModalOpen = false;

  fields = ["品目", "数量", "単位", "単価", "金額", "備考"];

  invoice = new Invoice();
  unitOptions: SelectOption[] = [];

  printing: boolean = false;

  async createPdf(id: number, printsExcludeTax: boolean) {
    if (!this.printing) {
      this.printing = true;
      const url = await printApi.getInvoicePrint(
        id,
        this.$store.state.accessToken,
        printsExcludeTax
      );
      this.printing = false;
      window.open(url, "請求書印刷");
    } else {
      alert("印刷中です");
    }
  }

  get statusOptions() {
    return InvoiceStatus.all().map(value => ({
      value,
      text: InvoiceStatusTranslater.toJp(value)
    }));
  }

  get childListClassName() {
    return {
      expanded: this.editing
    };
  }

  get bankAccountOptions(): string[] {
    return this.accounts.map(a => new BankAccountOption(a).value);
  }

  goListPage() {
    this.$router.push({
      name: "invoice"
    });
  }

  status = "";

  async save() {
    this.status = "progressing";
    try {
      await service.save(this.invoice);
      alert("保存しました。");
    } catch (error) {
      alert(error[0] || error);
    } finally {
      this.status = "";
    }
  }

  async destroy() {
    if (!confirm("本当に削除してもよろしいですか？")) return;
    await service.destroy(Number(this.id));
    this.goListPage();
  }

  async calculate() {
    this.invoice = await service.calculate(this.invoice);
  }

  addNewItem() {
    this.invoice.items.push(new InvoiceItemModel());
    this.calculate();
  }

  addNewFiveItems() {
    new Array(5).fill(0).forEach(() => {
      this.invoice.items.push(new InvoiceItemModel());
    });
    this.calculate();
  }

  addNewItemTo(index: number, items: InvoiceItemModel[]) {
    items.splice(index, 0, new InvoiceItemModel());
    this.calculate();
  }

  removeItem(item: InvoiceItemModel, items: InvoiceItemModel[]) {
    const i = items.findIndex(it => it.id === item.id);
    if (i < 0) return;
    items.splice(i, 1);
    this.calculate();
  }

  removeAllItems() {
    if (!confirm("全ての項目を削除します。よろしいですか？")) return;
    this.invoice.items = [];
    this.calculate();
  }

  move(e: MoveEvent) {
    // 子がいる親を子にすることはできない
    const from = e.from.dataset.type;
    const to = e.to.dataset.type;
    const children = e.draggedContext.element.items.length;
    return !(from === "parents" && to === "children" && children > 0);
  }

  dragstart() {
    this.editing = true;
  }

  dragend() {
    this.editing = false;
    this.calculate();
  }

  async updateDueDate() {
    this.invoice.dueDate = await service.getDueDate(
      this.invoice.billingDate,
      String(this.invoice.projectId)
    );
  }

  protected async created() {
    await this.loadInvoice();
    await this.loadBankAccountOptions();
    await this.initUnitList();
  }

  private editing = false;
  private accounts: BankAccount[] = [];

  private async loadInvoice() {
    this.invoice = await service.find(Number(this.id));
  }

  private async loadBankAccountOptions() {
    this.accounts = await bankAccountApi.ourBankAccounts({
      projectId: this.invoice.projectId
    });
  }

  private async initUnitList() {
    this.unitOptions = [
      { text: "", value: "" },
      ...(await unitApi.findAll()).map(UnitOption)
    ];
  }

  addTextToMention(text: string) {
    if (this.invoice.mention) {
      this.invoice.mention += "\n";
    }
    this.invoice.mention += text;
    this.textTemplateModalOpen = false;
  }
}
